"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.AssigneePill = exports.AssigneePillUnassigned = exports.UnassignedIcon = exports.AssigneePillWithUser = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var omni_continuity_1 = require("@hiyllo/omni-continuity");
var omni_images_1 = require("@hiyllo/omni-images");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var omni_search_1 = require("@hiyllo/omni-search");
var common_1 = require("./common");
var platform_1 = require("@hiyllo/ux/platform");
var react_native_1 = require("react-native");
exports.AssigneePillWithUser = react_1["default"].memo(function AssigneePillWithUser(props) {
    var _a = react_1["default"].useState(false), showPickAssignee = _a[0], setShowPickAssignee = _a[1];
    var self = (0, omni_continuity_1.useSelf)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [showPickAssignee ? ((0, jsx_runtime_1.jsx)(omni_search_1.SearchOverlay, { filterType: ["person"], stickyOptions: [
                    {
                        label: "Assign Self",
                        onSelect: function () {
                            if (props.onChangeAssignee != null) {
                                props.onChangeAssignee(self.userId);
                            }
                        }
                    },
                    {
                        label: "Unassign",
                        onSelect: function () {
                            if (props.onChangeAssignee != null) {
                                props.onChangeAssignee(null);
                            }
                        }
                    },
                ], onClose: function () { return setShowPickAssignee(false); }, onSelectResult: function (r) {
                    if (props.onChangeAssignee != null) {
                        props.onChangeAssignee(r.user.id);
                    }
                    setShowPickAssignee(false);
                } })) : null, (0, jsx_runtime_1.jsxs)(common_1.TaskPill, __assign({ label: props.hideLabel !== true ? "Assignee" : null, onClick: props.onChangeAssignee !== null
                    ? function () { return setShowPickAssignee(true); }
                    : undefined }, { children: [(0, jsx_runtime_1.jsx)(omni_images_1.UserImage, { userId: props.userId, width: 16 }), (0, jsx_runtime_1.jsx)(react_native_1.Text, __assign({ style: { color: "white", fontFamily: "hiyllo" } }, { children: props.name }))] }))] }));
});
exports.UnassignedIcon = react_1["default"].memo(function UnassignedIcon(props) {
    var FontAwesomeIcon = (0, platform_1.useFontAwesomeIcon)();
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, __assign({ style: {
            height: props.width,
            width: props.width,
            borderRadius: props.width * 0.25,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        } }, { children: (0, jsx_runtime_1.jsx)(FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faUserSlash, color: "white", size: props.width * 0.65 }) })));
});
exports.AssigneePillUnassigned = react_1["default"].memo(function AssigneePillUnassigned(props) {
    var _a = react_1["default"].useState(false), showPickAssignee = _a[0], setShowPickAssignee = _a[1];
    var self = (0, omni_continuity_1.useSelf)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [showPickAssignee ? ((0, jsx_runtime_1.jsx)(omni_search_1.SearchOverlay, { filterType: ["person"], stickyOptions: [
                    {
                        label: "Assign Self",
                        onSelect: function () {
                            if (props.onChangeAssignee != null) {
                                props.onChangeAssignee(self.userId);
                            }
                        }
                    },
                    {
                        label: "Unassign",
                        onSelect: function () {
                            if (props.onChangeAssignee != null) {
                                props.onChangeAssignee(null);
                            }
                        }
                    },
                ], onSelectResult: function (r) {
                    if (props.onChangeAssignee != null) {
                        props.onChangeAssignee(r.user.id);
                    }
                    setShowPickAssignee(false);
                }, onClose: function () { return setShowPickAssignee(false); } })) : null, (0, jsx_runtime_1.jsxs)(common_1.TaskPill, __assign({ label: props.hideLabel !== true ? "Assignee" : null, onClick: props.onChangeAssignee !== null
                    ? function () { return setShowPickAssignee(true); }
                    : undefined }, { children: [(0, jsx_runtime_1.jsx)(exports.UnassignedIcon, { width: 16 }), (0, jsx_runtime_1.jsx)(react_native_1.Text, __assign({ style: { color: "white", fontFamily: "hiyllo" } }, { children: "Unassigned" }))] }))] }));
});
// todo are we cacheing data and users correctly?
exports.AssigneePill = react_1["default"].memo(function PriorityPill(_a) {
    var _b, _c, _d;
    var hideLabel = _a.hideLabel, assignee = _a.assignee, onChangeAssignee = _a.onChangeAssignee;
    var lookup = (0, omni_continuity_1.useLookupByUserId)(assignee);
    if (assignee === null) {
        return ((0, jsx_runtime_1.jsx)(exports.AssigneePillUnassigned, { onChangeAssignee: onChangeAssignee, hideLabel: hideLabel }));
    }
    return ((0, jsx_runtime_1.jsx)(exports.AssigneePillWithUser, { onChangeAssignee: onChangeAssignee, name: (_c = (_b = lookup.data) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "", profilePictureSrc: (_d = lookup.data) === null || _d === void 0 ? void 0 : _d.profilePictureSrc, hideLabel: hideLabel, userId: assignee }));
});
